import { PartialTranslation } from '../translations';

export const sr: PartialTranslation = {
  newChat: 'Нови разговор',
  search: 'Претрага',
  user: 'Корисник',
  settings: 'Подешавања',
  language: 'Језик',
  getHelp: 'Добити помоћ',
  viewAllPlans: 'Погледајте све планове',
  learnMore: 'Сазнајте више',
  logOut: 'Одјавити се',
  chooseLanguage: 'Изаберите језик',
  chooseYourPreferredLanguage: 'Изаберите жељени језик',
  searchLanguages: 'Претражите језике...',
  autoDetect: 'Аутоматска детекција',
  noLanguagesFound: 'Нису пронађени језици',
  askAnything: 'Питајте било шта',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Лични',
  freePlan: 'Бесплатни план',
  current: 'Тренутни',
  close: 'Затворити',
  archive: 'Архивирати',
  delete: 'Обрисати',
  confirmDelete: 'Јесте ли сигурни да желите да обришете овај разговор?',
  confirmArchive: 'Јесте ли сигурни да желите да архивирате овај разговор?',
  deleteCannotUndo: 'Ова радња се не може поништити.',
  archiveCanFind: 'Можете је пронаћи у листи архиве након архивирања.',
  // 资源面板
  resources: 'Ресурси',
  addResource: 'Додај ресурс',
  deleteResource: 'Обриши ресурс',
  noMatchingResourcesFound: 'Нису пронађени одговарајући ресурси',
  noResourcesAvailable: 'Нема доступних ресурса',
  hideResources: 'Сакриј ресурсе',
  showResources: 'Прикажи ресурсе',
  
  // 聊天输入框
  typeMessage: 'Напишите поруку...',
  thinkingOptions: 'Опције размишљања',
  deleteFile: 'Обриши фајл',
  clearSelection: 'Очисти селекцију',
  
  // 思考模式选项
  deepInsight: 'Дубок увид · Површинска анализа',
  deepInsightDesc: 'Брзо разумевање кључних тачака',
  deepExploration: 'Дубоко истраживање · Свеобухватна анализа',
  deepExplorationDesc: 'Вишедимензионално дубинско истраживање',
  deepDeconstruction: 'Дубока деконструкција · Систематски аргумент',
  deepDeconstructionDesc: 'Анализа слој по слој',
  
  // 写作模式选项
  contractReview: 'Преглед уговора · Идентификација ризика',
  contractReviewDesc: 'Анализа клаузула и провера усаглашености',
  textPolish: 'Полирање текста · Професионално изражавање',
  textPolishDesc: 'Оптимизација језика и прилагођавање структуре',
  legalDocuments: 'Правни документи · Стандардно писање',
  legalDocumentsDesc: 'Професионално писање правних докумената',
  addAttachment: 'Додај прилог',
  sendMessage: 'Пошаљи поруку',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Пријава',
  register: 'Регистрација',
  welcomeBack: 'Добродошли у LawHelper',
  loginSubtitle: 'Ваш AI асистент за правна истраживања',
  continueWithGoogle: 'Настави са Google',
  continueWithMicrosoft: 'Настави са Microsoft',
  continueWithWeChat: 'Настави са WeChat',
  orContinueWith: 'или настави са',
  emailTab: 'Имејл',
  phoneTab: 'Телефон',
  emailPlaceholder: 'Унесите ваш имејл',
  phonePlaceholder: 'Унесите број телефона',
  codePlaceholder: 'Унесите 6-цифрени код',
  sending: 'Слање...',
  verifying: 'Провера...',
  verify: 'Потврди',
  sendMagicLink: 'Пошаљи магични линк',
  getVerificationCode: 'Добиј код',
  resendCode: 'Поново пошаљи код',
  resendIn: 'Поново пошаљи за',
  magicLinkSent: 'Магични линк је послат на ваш имејл',
  magicLinkHint: 'Послаћемо вам сигуран линк на вашу адресу',
  otpSent: 'Код за потврду је послат',
  agreeToTerms: 'Настављањем се слажете са нашим',
  privacyPolicy: 'Политика приватности',
  termsOfService: 'Услови коришћења',
  and: 'и',
  privacyTitle: 'Ваша приватност је важна',
  privacyIntro: 'Користимо колачиће и сличне технологије да вам пружимо најбоље искуство.',
  essentialCookies: 'Неопходни колачићи',
  essentialDesc: 'Потребни за функционисање сајта',
  analyticsCookies: 'Аналитички колачићи',
  analyticsDesc: 'Помажу нам да побољшамо услугу',
  marketingCookies: 'Маркетиншки колачићи',
  marketingDesc: 'Користе се за персонализовани садржај',
  acceptAll: 'Прихвати све',
  essentialOnly: 'Само неопходни',
  customize: 'Прилагоди',
  savePreferences: 'Сачувај подешавања',
  back: 'Назад',
  readPrivacyPolicy: 'Прочитајте нашу политику приватности',
  cookiePolicy: 'Политика колачића',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI преглед',
  aiDraft: 'AI нацрт',
  smartAssistant: 'Шаблон',

  // 知识库搜索
  enableKnowledgeSearch: 'Омогући претрагу',
  knowledgeSearchDesc: 'AI претражује ваше документе',
  clickToDisable: 'Онемогући',
  clickToEnable: 'Омогући',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Затвори панел ресурса',
  uploading: 'Отпремање %{fileName}...',
  processing: 'Обрада %{fileName}...',
  uploadSuccess: '✓ %{fileName} отпремљен',
  uploadError: '✗ Отпремање неуспешно: %{error}',
  quickAnswer: 'Брз одговор',
  quickAnswerDesc: 'Брз одговор на једноставна питања',
  cancelRequest: 'Откажи',
  library: 'Библиотека',
  filterAll: 'Све',
  filterChat: 'Ћаскања',
  filterReview: 'Преглед',
  filterDraft: 'Нацрт',
  filterTemplate: 'Шаблон',
  filterForm: 'Формулар',
  thinking: 'Размишљам...',
  thinkingProcess: 'Мисаони процес',
  analyzingLegalLogic: 'Анализа правне логике...',
  lawhelperThinking: 'Lawhelper размишља...',
  serviceError: 'Грешка сервиса',
  uploaded: 'Отпремљено',
  settingsGeneral: 'Опште',
  settingsNotifications: 'Обавештења',
  settingsAppearance: 'Изглед',
  settingsProfile: 'Профил',
  settingsResponseNotifications: 'Обавештења о одговорима',
  settingsResponseNotificationsDesc: 'Обавештење по завршетку AI одговора',
  settingsColorMode: 'Режим боја',
  settingsLight: 'Светло',
  settingsDark: 'Тамно',
  settingsSystem: 'Систем',
  about: 'О апликацији',
  reviewTitle: 'Преглед документа',
  exitReview: 'Изађи из прегледа',
  uploadPrompt: 'Отпремите PDF за преглед',
  uploadButton: 'Изабери фајл',
  startChatConfig: 'Напишите "Прегледај овај документ"',
  reviewPlaceholder: 'Унесите поруку...',
  analyzing: 'Прегледање...',
  reviewComplete: 'Преглед завршен',
  issuesFound: 'Пронађено %{count} проблема',
  draftTitle: 'Израда правног документа',
  draftPlaceholder: 'Уредите овде или затражите од AI...',
  analyzingTemplate: 'Анализа шаблона %{name}...',
  templateAnalyzed: '✅ Шаблон %{name} анализиран!',
  templateAnalysisPrompt: 'Анализирај кључне клаузуле',
  parsingFailed: '⚠️ Неуспешна анализа фајла.',
  generating: 'Генерисање...',
  generatedSuccess: '✅ Документ генерисан!',
  drafterWelcome: 'Добродошли у AI асистент за документе',
  drafterYouCan: 'Можете:',
  drafterUploadTemplate: 'Отпремити шаблон за AI анализу',
  drafterDescribeNeeds: 'Описати захтеве документа',
  drafterLetAiHelp: 'AI помаже са уговорима, споразумима итд.',
  drafterExamples: 'Примери:',
  drafterExampleRental: '"Саставите уговор о закупу"',
  drafterExampleLabor: '"Попуните уговор о раду"',
  drafterInputPlaceholder: 'Опишите потребе...',
  drafterThinking: 'Размишљам...',
  drafterHistoryTitle: 'Историја',
  drafterNoHistory: 'Нема историје',
  drafterNewChat: 'Нови чат',
  drafterHistory: 'Историја',
  drafterRemoveAttachment: 'Уклони прилог',
  drafterLineHeight: 'Висина реда',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Извоз у Word (.docx)',
  drafterExportPdf: 'Извоз у PDF',
  drafterSave: 'Сачувај документ',
  drafterDownload: 'Преузми документ',
  drafterUndo: 'Поништи',
  drafterRedo: 'Понови',
  drafterBold: 'Подебљано',
  drafterItalic: 'Курзив',
  drafterStrike: 'Прецртано',
  drafterUnderline: 'Подвучено',
  drafterHighlight: 'Истакни',
  drafterLink: 'Уметни линк',
  drafterAlignLeft: 'Лево',
  drafterAlignCenter: 'Центар',
  drafterAlignRight: 'Десно',
  drafterAlignJustify: 'Обострано',
  drafterList: 'Листа',
  drafterBulletList: 'Ненумерисана листа',
  drafterOrderedList: 'Нумерисана листа',
  drafterTaskList: 'Листа задатака',
  drafterOpenResource: 'Отвори ресурсе',
  drafterStopGeneration: 'Заустави генерисање',
  drafterAgentMode: 'Агент режим активан',
  drafterAgentModeOn: 'Агент режим активан',
  drafterAgentModeOff: 'Нормалан режим',
  drafterUploadAttachment: 'Отпреми прилог',
  drafterExit: 'Изађи',
  drafterConfirm: 'Потврди',
  drafterOpenLink: 'Отвори линк',
  drafterDeleteLink: 'Обриши линк',
  drafterQuote: 'Цитат',
  workflowTitle: 'AI процес',
  workflowRunning: 'Извршава се...',
  workflowReady: 'Спреман',
  workflowCompleted: 'Завршен',
  workflowStartFailed: 'Неуспешан покретање',
  workflowExecutionFailed: 'Неуспешно извршавање',
  workflowInterrupted: 'Процес прекинут',
  workflowProcessing: 'Обрада...',
  workflowStepsCompleted: 'корака завршено',
  workflowStepsTotal: 'Процес завршен (%{count} корака)',
  acceptChanges: 'Прихвати измене',
  rejectChanges: 'Одбаци измене',
  changesAccepted: 'Измене прихваћене',
  changesRejected: 'Измене одбачене',
  stopWorkflow: 'Заустави',
  restartWorkflow: 'Рестарт',
  startDrafting: 'Почни израду',
  interrupt: 'Заустави',
  documentSubject: 'Тема документа *',
  documentType: 'Тип документа',
  jurisdiction: 'Јурисдикција',
  specialRequirements: 'Посебни захтеви (опционо)',
  clickStartDrafting: 'Притисните "Почни израду"',
  docTypeContract: 'Уговор',
  docTypeAgreement: 'Споразум',
  docTypeNotice: 'Обавештење',
  docTypeLetter: 'Писмо',
  docTypePetition: 'Петиција',
  docTypeWill: 'Тестамент',
  docTypePowerOfAttorney: 'Пуномоћје',
  countryChina: 'Кина',
  countryUSA: 'САД',
  countryGermany: 'Немачка',
  countryJapan: 'Јапан',
  countryFrance: 'Француска',
  countryUK: 'Велика Британија',
  citationVerified: 'Верификовано',
  citationUnverified: 'Неверификовано',
  imageLoadFailed: 'Неуспешно учитавање слике',
  smartDocTitle: 'Паметни асистент',
  smartDocChatTitle: 'AI асистент за документе',
  smartDocDropPrompt: 'Превуците PDF овде',
  smartDocSelectFile: 'Изабери фајл',
  smartDocOr: 'или',
  smartDocWelcomeTitle: 'Добродошли у AI асистент',
  smartDocWelcomeYouCan: 'Можете:',
  smartDocUploadForAI: 'Отпремити шаблон',
  smartDocDescribeDoc: 'Описати захтеве',
  smartDocLetAIDraft: 'AI помаже са уговорима',
  smartDocExamples: 'Примери:',
  smartDocExampleRental: '"Саставите уговор о закупу"',
  smartDocExampleLabor: '"Попуните уговор о раду"',
  smartDocInputPlaceholder: 'Опишите потребе...',
  smartDocRemoveAttachment: 'Уклони прилог',
  smartDocOpenResources: 'Отвори ресурсе',
  smartDocExit: 'Изађи',
  reviewStartFailed: 'Неуспешан покретање прегледа',
  reviewFailed: 'Преглед неуспешан',
  reviewFoundIssues: 'Преглед завршен, %{count} проблема.',
  cannotReadStream: 'Не може се читати ток',
  parseEventFailed: 'Неуспешна анализа догађаја',
  errorPrefix: 'Грешка',
  unknownError: 'Непозната грешка',
  file: 'Фајл',
  loading: 'Учитавање...',
  localFolders: 'Локалне фасцикле',
  selectLocalFolder: 'Изабери локалну фасциклу',
  reselectFolder: 'Промени фасциклу',
  addToContext: 'Додај у чат',
  saveFile: 'Сачувај',
  renameFile: 'Преименуј',
  fileSaved: 'Фајл сачуван',
  fileRenamed: 'Фајл преименован у %{name}',
  browserNotSupported: 'Прегледач не подржава приступ фасциклама',
  noFolderSelected: 'Изаберите локалну фасциклу',
  scanningFolder: 'Скенирање фасцикле...',
  selectFileToPreview: 'Изаберите фајл за преглед',
  aiAnalyze: 'AI анализа',
};
